import React from 'react';
import { ReactComponent as ArrowIcon } from './icons/arrow-right.svg';

interface NavButtonProps
	{
	direction: 'prev' | 'next';
	onClick: () => void;
	disabled?: boolean;
	color?: string;
	}

// Reusable prev/next arrow button — used by every date-picker calendar and,
// via the matching `ocean-nav-button` classes, styled consistently anywhere
// else a paging arrow is needed (see `carouselArrow` in scss/_mixins.scss
// for the PHP/vanilla-JS slider equivalent).
//
export const NavButton = ({ direction, onClick, disabled, color = 'var(--wp--preset--color--bamaluz-word-red)' }: NavButtonProps) => (
	<button
		type="button"
		className={`ocean-nav-button ocean-nav-button--${direction}`}
		style={{ color }}
		onClick={onClick}
		disabled={disabled}
		aria-label={direction === 'prev' ? 'Previous month' : 'Next month'}
	>
		<ArrowIcon className="ocean-nav-button-icon" />
	</button>
);
